import React from 'react';

import Paper from '~/components/core/Atomic/Paper';

import UserClaimsNotifications from './UserClaimsNotificationsContainer';

function NotificationsPage() {
  return (
    // The <Paper> is needed for the scroll to work
    <Paper>
      <UserClaimsNotifications />
    </Paper>
  );
}

export default NotificationsPage;
